<template>
  <section class="p-6">
    <div class="flex justify-between mb-2">
      <h1>Dog Clothes</h1>
      <button
        @click="openCreateModal"
        class="bg-pink-300 text-white font-bold py-2 px-4 rounded"
      >
        +
      </button>
    </div>

    <div class="grid grid-cols-2 lg:grid-cols-4 gap-3 py-10">
      <div
        v-for="product in products"
        :key="product.id"
        class="bg-white shadow-lg thumbnail"
      >
        <div class="relative">
          <div
            class="overlay absolute z-10 w-full h-full flex items-center justify-center"
          >
            <button @click="removeProduct(product.id)" class="btn">
              trash
            </button>
            <button
          
              @click="editModal(product)"
              class="bg-purple-400 text-white font-bold py-2 px-4 rounded"
            >
              Edit
            </button>
          </div>
          <img
            class="w-full"
            :src="product.image"
            :alt="'Image of a' + product.name"
          />
        </div>
        <div class="p-2">
          <h2 class="font-bold">{{ product.name }}</h2>
          <p>${{ product.price }}</p>
        </div>
      </div>
    </div>
    <edit-dog-modal @exit="closeModal" v-if="modal" v-model="form" />
  </section>
</template>
<script>
import { db } from "@/db";
import EditDogModal from "@/components/EditDogModal.vue";

export default {
  data: function () {
    return {
      form: {},
      modal: false,
      products: [],
    };
  },
  components: {
    EditDogModal,
  },
  methods: {
    // create
    openCreateModal() {
      this.form = {
        name: null,
        price: 2.99,
        description: null,
        image: null,
        feature: false,
      };
      this.modal = true;
    },
    closeModal() {
      this.modal = false;
    },
    editModal(product) {
      this.form = product;
      this.modal = true;
    },
    // delete
    removeProduct(id) {
      db.collection("products").doc(id).delete();
    },
  },
  firestore: {
    products: db.collection("products"),
  },
};
</script>
<style scoped>
.thumbnail .overlay {
  opacity: 0;
}

.thumbnail:hover .overlay {
  opacity: 1;
}
</style>